import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./CardImageCap.styled";
export const CardImageCap = forwardRef((props, ref) => {
    const { children, height, src, alt = "", ...otherProps } = props;
    return (_jsxs(Styled.CardImageCap, { "data-testid": "CardImageCap", height: height, ref: ref, ...otherProps, children: [src && _jsx("img", { src: src, alt: alt }), children] }));
});
CardImageCap.displayName = "CardImageCap";
